var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import SelectSurveyForm from "./SelectSurveyForm";
import useUniqueId from "../../Hooks/useUniqueId";
import { AlertInfo, AlertSuccess, } from "../../UI/StandardAlerts/StandardAlerts";
import SurveyService from "../../../Services/Survey.service";
import useService from "../../Hooks/useService";
import PersonService from "../../../Services/Person.service";
import ShowMoreList, { StringShowMoreListRenderer, } from "../../UI/ShowMoreList/ShowMoreList";
import { MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL } from "../../Container/Pipeline/PipelineDetailListMenu";
const SendSurveyToOpportunitiesModal = (_a) => {
    var { opportunities } = _a, modalProps = __rest(_a, ["opportunities"]);
    const opportunityIds = opportunities.map((o) => o.id);
    const makeId = useUniqueId()[1];
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const defaultValue = React.useMemo(() => ({
        comment: `${me.data ? me.data.fullName : ""} sent a survey to a selected opportunities`,
    }), [me.data]);
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { keepModalOpenAfterSuccess: _jsx(AlertSuccess, { message: "Survey successfully sent to the selected opportunities." }), respondToDefaultValueChanges: true, modalTitle: "New Survey", saveButtonContents: () => "Send", confirmSubmit: "You are sending this survey to all selected opportunities.  Are you sure you want to proceed?", defaultValue: defaultValue, handleSubmit: (state) => SurveyService.sendToOpportunities({
            opportunityIds,
            surveyId: state.survey.id,
            comments: state.comment,
        }), children: (useFormProps) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: makeId("opportunities"), children: ["Opportunities (", opportunities.length, ")"] }), _jsx("div", { id: makeId("opportunities"), children: _jsx(ShowMoreList, { numOfItemsToPreview: MAX_OPPORTUNITIES_PREVIEWED_ON_MODAL, renderer: StringShowMoreListRenderer, items: opportunities.map((o) => o === null || o === void 0 ? void 0 : o.subject.fullName) }) })] }), _jsx(SelectSurveyForm, Object.assign({}, useFormProps)), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("comment"), children: "Comment" }), _jsx("textarea", { id: makeId("comment"), ref: useFormProps.register, name: "comment", className: "form-control" })] }), _jsx(AlertInfo, { message: "The survey results will appear on the Surveys tab corresponding to each recipient." })] })) })));
};
export default SendSurveyToOpportunitiesModal;
